import { styled } from "styled-components";

export const CampanhasPageContainer = styled.div`
  display: flex;
`;
